export const GET_USER_DETAILS_API_TAG = 'userDetails';
export const CREATE_BENEFIT_GROUP_API_TAG = 'getBenefitGroups';
export const GET_BENEFIT_GROUP_DEFAULT_SETTINGS_API_TAG =
  'getBenefitGroupsDefaultSettings';

export const BENEFICIARY_TAGS = [
  'beneficiaryDetails',
  'companyBeneficiariesList'
];
export const GET_BENEFIT_GROUP_DETAILS_API_TAG = 'getBenefitGroupDetails';

export const USER_TAGS = [GET_USER_DETAILS_API_TAG];
export const BENEFIT_GROUPS = [
  CREATE_BENEFIT_GROUP_API_TAG,
  GET_BENEFIT_GROUP_DEFAULT_SETTINGS_API_TAG,
  GET_BENEFIT_GROUP_DETAILS_API_TAG
];

export const ALL_API_TAGS = [
  ...USER_TAGS,
  ...BENEFICIARY_TAGS,
  ...BENEFIT_GROUPS
] as const;
